import { DataTableColumnHeader } from '@/components/admin/members/ColHeader'
import { CaseWorker } from '@/store/user'
import { Cfl, cn } from '@repo/ui/utils'
import { ColumnDef } from '@tanstack/react-table'
import { ReactNode } from 'react'

export const columns = (
  renderAction: (props: { caseWorker: CaseWorker }) => ReactNode,
): ColumnDef<CaseWorker>[] => [
  {
    accessorKey: 'lastName',
    header: ({ column }) => {
      return (
        <DataTableColumnHeader
          column={column}
          options={{ sortable: true, searchable: true }}
        />
      )
    },
  },
  {
    accessorKey: 'firstName',
    header: ({ column }) => {
      return (
        <DataTableColumnHeader
          column={column}
          options={{ sortable: true, searchable: true }}
        />
      )
    },
  },
  {
    accessorKey: 'email',
    header: ({ column }) => {
      return (
        <DataTableColumnHeader
          column={column}
          options={{ sortable: true, searchable: true }}
        />
      )
    },
  },
  {
    accessorKey: 'status',
    header: ({ column }) => {
      return (
        <DataTableColumnHeader
          column={column}
          options={{
            sortable: true,
            filterable: ['pending', 'enabled', 'disabled'],
          }}
        />
      )
    },
    cell: ({ row, column }) => {
      const value = row.getValue<string>(column.id)
      return (
        <div
          className={cn(
            value === 'pending' && 'text-orange-500',
            value === 'disabled' && 'opacity-50',
          )}
        >
          {Cfl(value)}
        </div>
      )
    },
  },
  {
    accessorKey: 'role',
    header: ({ column }) => {
      return (
        <DataTableColumnHeader
          column={column}
          options={{ sortable: true, filterable: ['admin', 'case worker'] }}
        />
      )
    },
    cell: ({ row, column }) => {
      const value = row.getValue<string>(column.id)
      return (
        <div className={cn(value === 'admin' && 'text-highlight')}>
          {Cfl(value)}
        </div>
      )
    },
  },
  {
    id: 'actions',
    cell: ({ row }) => {
      const caseWorker = row.original
      return <>{renderAction({ caseWorker })}</>
    },
  },
]
